import React from "react";
import {
  SubmitButton,
  TextComponent,
  TextHeader,
} from "../../../../components";
import { AiFillPlusCircle } from "react-icons/ai";
import styles from "./QA.module.css";
import { Col, List, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setRSVP } from "../../../../Store/Actions/EventPlanningActions";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

const QA = () => {
  const Qna = useSelector((state) => state.EventPlanningReducer.Qna);
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const next = () => {
    if (Qna?.length == 0 || !Qna[Qna?.length - 1].question) {
      dispatch(
        showAlert({
          title: "QNA",
          message: "Please add few Questions!",
          status: 400,
        })
      );
    } else {
      let data = {
        ...RSVP,
        QNA: Qna,
      };
      dispatch(setRSVP(data));
      navigate("/events/rsvp/requestedrsvp", {
        state: { headrTitle: "Request RSVP" },
      })
      // navigation.navigate("SendToGuest")
    }
  };
  return (
    <div>
      <Row className={styles.textRow}>
        <Col>
          <TextHeader
            text={"8. Q/A "}
            containerClass={styles.textContainer}
            textClass={styles.textHeading}
          />
        </Col>
        <Col>
          <div
            className={styles.innerContainer}
            onClick={() =>
              navigate("/events/rsvp/addquestions", {
                state: { headrTitle: "Add Question" },
              })
            }
          >
            <AiFillPlusCircle className={styles.icon} size={40} />
            <TextComponent text={"Add Question"} textClass={styles.innertext} />
          </div>
        </Col>
      </Row>
      <Col className={styles.col}>
        <TextComponent
          text={"For all our friends and family who "}
          textClass={""}
        />
        <TextComponent
          text={"have lots of questions, please check out our"}
          textClass={""}
        />
      </Col>
      <List
        grid={{
          gutter: 16,
          xs: 2,
          sm: 2,
          md: 2,
          lg: 2,
          xl: 2,
          xxl: 2,
        }}
        className={styles.list}
        dataSource={Qna}
        renderItem={(item, index) => {
          return (
            <Row  className={styles.row} key={index}>
              <Col  className={styles.containerHeader}>
                <div className={styles.containerRow}>
                  <TextComponent
                    textClass={styles.label}
                    text={item.question}
                  />
                  <TextComponent textClass={styles.label1} text={item.answer} />
                </div>
              </Col>
            </Row>
          );
        }}
      />
     

      <SubmitButton
        btnClass={styles.btnClass}
        title="Next"
        onClick={next}
      />
    </div>
  );
};

export default QA;
